<template>
    <div class="float-left mr-1" v-if="convenio.idSituacaoConvenio != 9">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Ação"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <acao-plano-trabalho-form
            operacaoProp="A"
            :convenio="convenio"
            :acao="acao"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></acao-plano-trabalho-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import AcaoPlanoTrabalhoForm from './AcaoPlanoTrabalhoForm.vue'

export default {
    components: {
        AcaoPlanoTrabalhoForm
    },

    props: {
        convenio: Object,
        acao: Object
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(acao) {
            this.$store.dispatch('addRequest')
            let acaoDto = {
                nomeAcao: acao.nomeAcao,
                codGestor: acao.codGestor,
                vcCodUnidade: acao.VcCodUnidade,
                idAcaoPlanoTrabalho: acao.idAcaoPlanoTrabalho,
                idConvenio: acao.idConvenio,
                codSituacao: acao.codSituacao,
                emailGestor: acao.emailGestor,
                nomeGestor: acao.nomeGestor,
                nomeUnidade: acao.nomeUnidade
            }
            ConveniosServicos.alterarAcaoPlanoTrabalho(acaoDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Ação atualizada com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
